module.exports = __webpack_public_path__ + "media/images/ns-app-battery-icon-10-2481e5f34e1a14a7d44a7dfb500a2861.svg";